import React, { useEffect, useState, useRef } from 'react';
import bemit from 'Functions/bemit';
import Layout from 'Layouts/Front';
import axios from 'axios';
import { getSpacedPhoneNumber } from 'Shared/utilities';
import { action, URL } from 'Shared/Routes';
import { MAPS_API_KEY } from 'front_env';
export default function EtablishmentsMapPage(props) {
  const [etablishmentsData, setEtablishmentData] = useState([]);
  const [spacesData, setSpacesData] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const open_info_window = useRef();
  useEffect(() => {
    fetchEtablishments();
    fetchCoworkingSpaces();
  }, []);
  useEffect(() => {
    setIsLoaded(true);
    isLoaded && loadScript();
  }, [etablishmentsData]);
  const fetchEtablishments = async () => {
    try {
      const response = await axios.post(action('searchAllEtablishments'), {});
      setEtablishmentData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchCoworkingSpaces = async () => {
    try {
      const response = await axios.post(action('getAllCoworkingSpaces'), {
        from_public_map: true
      });
      setSpacesData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  const loadScript = async () => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${MAPS_API_KEY}&callback=app.initGoogleMap`;
    script.async = true;
    script.defer = true;
    script.addEventListener('load', initMap);
    document.body.appendChild(script);
  };
  const initMap = () => {
    const map = new window.google.maps.Map(document.getElementById('map'), {
      center: {
        lat: 46.227638,
        lng: 2.213749
      },
      zoom: 6
    });
    etablishmentsData.forEach(etablishment => {
      const marker = new window.google.maps.Marker({
        position: {
          lat: etablishment.geometry.location.lat,
          lng: etablishment.geometry.location.lng
        },
        map: map,
        title: etablishment.name,
        icon: {
          url: '/images/map_pin.svg',
          scaledSize: new window.google.maps.Size(40, 40)
        }
      });
      const etablishmentSpaces = spacesData.filter(space => space.etablishment_id === etablishment.id);
      const uniqueSpaces = new Set();
      etablishmentSpaces.forEach(space => {
        if (space.type === 'c_open_coworking_space') {
          uniqueSpaces.add('<div class="c-etablishment-recap__space-type"> Lib</div>');
        }
        if (space.type === 'a_calm_coworking_space') {
          uniqueSpaces.add('<div class="c-etablishment-recap__space-type"> Lounge</div>');
        }
        if (space.type === 'b_seminar') {
          uniqueSpaces.add('<div class="c-etablishment-recap__space-type"> Meeting</div>');
        }
      });
      const spaces = [...uniqueSpaces].join('');
      const phoneNumber = etablishment.phone_number.split(' ').join('');
      const etablishment_href = URL('FrontEtablishmentPage').replace(':slug', etablishment.slug);
      marker.addListener('click', () => {
        const info_window = new window.google.maps.InfoWindow({
          content: `
					<div class="c-etablishment-recap map-popup">
						<img class="c-etablishment-recap__img"
							src="${etablishment.images?.[0].url}"
							alt="${etablishment.name}"
							/>
						<h3 class="c-etablishment-recap__title">
							<a class="c-etablishment-recap__title-link"
							href="/etablissements/${etablishment.slug}">
								${etablishment.name}
							</a>
						</h3>
						<div class="c-etablishment-recap__infos">
							<div class="c-etablishment-recap__column">
								<h4 class="c-etablishment-recap__subtitle">
									Contact
								</h4>
								<a class="c-infos-label c-infos-label--phone-number" href="tel:${phoneNumber}">
									<div class="c-infos-label__title">
										<img src="/images/icons/phone.svg" width="14" alt="phone" class="map-popup__phone-icon"/>
									</div>
									<span className="c-infos-label__map-popup">
										${getSpacedPhoneNumber(etablishment.phone_number)}
									</span>
								</a>
							</div>
							<div class="c-etablishment-recap__column">
								<h4 class="c-etablishment-recap__subtitle">
									Espaces proposés
								</h4>
								<ul class="c-etablishment-recap__spaces-types">${spaces}</ul>
							</div>
							<div class="u-full-width u-text-center u-margin-top-15">
								<a href="${etablishment_href}" class="${bemit('c-flat-btn', ['blue', 'v2', 'map-details-btn']) + ' u-margin-bottom-10'}">
									Voir les disponibilités
								</a>
							</div>
						</div>
					</div>`
        });
        try {
          if (open_info_window.current) {
            open_info_window.current.close?.();
          }
        } finally {
          open_info_window.current = info_window;
          info_window.open(map, marker);
        }
      });
    });
  };
  return /*#__PURE__*/React.createElement(Layout, props, /*#__PURE__*/React.createElement("div", {
    className: bemit('c-front-page-intro', ['search-results-page'])
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-front-page-intro__bg"
  }), /*#__PURE__*/React.createElement("h1", {
    className: "c-front-page-intro__title"
  }, "Carte des \xE9tablissements")), /*#__PURE__*/React.createElement("div", {
    className: "etablisments-map-page__map-container"
  }, /*#__PURE__*/React.createElement("div", {
    id: "map",
    style: {
      width: '100%',
      height: '800px'
    }
  })));
}
